import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export interface RsvpBadgeIconProps extends SvgIconProps {}

export const RsvpBadgeIcon = ({ style, ...iconProps }: RsvpBadgeIconProps) => {
  return (
    <SvgIcon
      style={{ fontSize: '1em', ...style }}
      {...iconProps}
      viewBox="0 0 144 80"
    >
      <path
        d="M10.5 1H133.5C138.471 1 142.5 5.02944 142.5 10V20.3242C142.5 23.2454 141.082 25.9849 138.697 27.6719L133.611 31.2695C127.414 35.6529 127.414 44.8471 133.611 49.2305L138.697 52.8281C141.082 54.5151 142.5 57.2546 142.5 60.1758V70C142.5 74.9706 138.471 79 133.5 79H10.5C5.52944 79 1.5 74.9706 1.5 70V10C1.5 5.02944 5.52944 1 10.5 1Z"
        fill="white"
        stroke="#5F666C"
        strokeWidth="2"
      />

      <g transform="translate(1 19)">
        <path
          d="M121.739 1C121.638 1.11593 121.53 1.23514 121.421 1.36133C120.313 2.64401 118.833 4.45119 117.352 6.54688C115.872 8.63994 114.378 11.0399 113.25 13.5059C112.127 15.9617 111.337 18.5486 111.337 21C111.337 23.4514 112.127 26.0383 113.25 28.4941C114.378 30.9601 115.872 33.3601 117.352 35.4531C118.833 37.5488 120.313 39.356 121.421 40.6387C121.53 40.7649 121.638 40.8841 121.739 41H1V1H121.739Z"
          fill="#E7E8EA"
          stroke="#5F666C"
          strokeWidth="2"
        />

        <text
          x="62"
          y="26"
          textAnchor="middle"
          fill="#5F666C"
          style={{
            fontFamily: 'Poppins, sans-serif',
            fontWeight: 700,
          }}
          fontSize="21"
        >
          RSVP
        </text>
      </g>
    </SvgIcon>
  );
};

export default RsvpBadgeIcon;
